var map = {
	"./administration.svg": 3528,
	"./angleDoubleLeft.svg": 1995,
	"./angleDoubleRight.svg": 1566,
	"./angleLeft.svg": 7336,
	"./angleRight.svg": 7271,
	"./apply.svg": 9370,
	"./arrow-down.svg": 6822,
	"./arrow-right.svg": 4944,
	"./arrows-left.svg": 3682,
	"./arrows-right.svg": 3961,
	"./assistants.svg": 2081,
	"./attachment.svg": 6353,
	"./chats.svg": 9659,
	"./clear.svg": 6389,
	"./dots.svg": 6358,
	"./home.svg": 2067,
	"./info.svg": 3458,
	"./integrations.svg": 4075,
	"./logo.svg": 3443,
	"./logout.svg": 9184,
	"./models.svg": 8720,
	"./plus.svg": 7542,
	"./profile.svg": 2425,
	"./progress.svg": 2099,
	"./reply.svg": 3142,
	"./search.svg": 6994,
	"./send.svg": 9660,
	"./settings.svg": 273,
	"./sources.svg": 5912,
	"./tasks.svg": 9384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;